import { render } from "./CreateGeo.vue?vue&type=template&id=52992116"
import script from "./CreateGeo.vue?vue&type=script&lang=js"
export * from "./CreateGeo.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__